<template>
  <div :id="chatItem?.id" :class="'evaluation-sum'">
    <div v-if="chatItem?.id" class="write-message" :class="{
                'read': pageType === 'read' && itemKey == 0,
                }">
      <div class="write-line">
        <div class="user-content">
          <div class="user-pic">
            <img :src="getUserPic(chatItem)" @error="handleIconError" alt="">
          </div>
          <div class="wrapper">
            <span v-if="chatItem?.clinicId" class="write-name mr-2">
              {{ chatItem.doctorName }} {{chatItem.doctorProfession}}
              <a :href="`clinic/${chatItem?.Clinic?.slug}`"> ({{chatItem.clinicName }})</a>
            </span>
            <span v-else class="write-name mr-2">{{ getUserName(chatItem) }}</span>
            <template v-if="chatItem?.clinicId">
            <span class="badge badge-success font-normal font-weight-normal width55">
              STR 驗證
            </span>
            </template>
          </div>
        </div>
        <div class="createTime id-tag">ID：{{ chatItem.id }}</div>
        <div class="createTime" data-toggle="tooltip" data-placement="top" :title="'更新時間:' + chatItem.updatedAt" v-html="timeAgo(chatItem.createdAt)"></div>
      </div>
      <div class="write-info" :class="position">
        <div class="write-depiction" v-html="convertMessage(chatItem)"></div>
      </div>
      <div v-if="pageType != 'read'" class="write-footer" :class="position">
        <div class="replyCount" :class="pageType">
          <div class="message-icon">
            <img src="img/pic/message.png" alt="icon" />
          </div>
          <div class="message">
<a :href="'onlineMedicalConsultation/'+chatItem.slug">{{ chatItem?.rootRepliesCount }}
            則留言</a>
</div>
        </div>
        <template v-if="pagePath != 'clinic'">
          <div v-if="chatItem?.RootReplies.length > 0 && chatItem?.RootReplies[0].doctorName" class="replyInfo"
             :class="pageType">
            <span v-if="chatItem?.RootReplies[0].doctorName" class="replyName">{{ chatItem?.RootReplies[0].doctorName }} {{
                chatItem?.RootReplies[0].doctorProfession
              }}
               <a :href="`clinic/${chatItem?.RootReplies[0]?.Clinic?.slug}`">({{
                  chatItem?.RootReplies[0].clinicName
                }})</a>
            </span>
          <div class="replyIcon hover-text">
              <span class="tooltip-text bottom">
                <template v-for="(item, key) in replyIconData">
                <div v-if="key < 5" class="replyNames">
                  {{ item.doctorName }} {{ item.doctorProfession }}<a
                    :href="`clinic/${item?.Clinic?.slug}`">({{ item.clinicName }})</a>
                </div>
                </template>
                <div v-if="replyIconData.length > 5">...</div>
              </span>
            <img v-for="(item, key) in replyIconData" v-if="key < 5" :src="getDoctorPic(item)"
                 @error="handleIconError" alt="" />
          </div>
        </div>
        </template>
      </div>
      <div v-else class="write-footer read">
        <template v-if="itemKey != 0">
          <div class="replyCount">
            <div class="message-icon">
              <img src="img/pic/message.png" alt="icon" />
            </div>
            <div class="message" @click="toggleReplies()">
<a>{{ chatItem?.repliesCount }}
              則留言</a>
</div>
          </div>
          <div class="reply-wrapper">
            <div v-if="canReply" class="reply-btn" @click="toggleReply()">回覆</div>
          </div>
        </template>
      </div>
    </div>
    <!-- 回覆表單 -->
    <div
        class="evaluation-lecturer reply-form"
        :class="{'reply-open' : replyFormShow, showReply}">
      <div v-if="authCheck" class="picIcon">
        <img :src="defaultPicIcon" title="" alt="">
      </div>
      <form v-if="canReply" style="overflow: hidden">
        <div class="input-content">
          <HtmlEditorPro
            :value="''"
            :inputName="'messageRender'"
            :inputNamePic="'Pics'"
          ></HtmlEditorPro>
          <button class="action-btn" :class="{
                'ajaxLoading': ajaxLoading
                }" type="button" :disabled="ajaxLoading" @click.prevent="submitForm">送出</button>
        </div>
      </form>
      <a v-else href="user/login" class="promptLoginBtn" title="">請先登入會員</a>
    </div>
    <!-- 回覆 -->
    <template v-if="chatItem?.id && pageType == 'read'">
      <div v-for="item in chatItem?.Replies" v-show="repliesContentShow" class="evaluation-lecturer replies">
        <div class="write-message">
          <div class="write-line">
            <div class="user-content">
              <div class="user-pic">
                <img :src="getUserPic(item)" @error="handleIconError">
              </div>
              <div class="wrapper">
                <span v-if="item?.clinicId" class="write-name mr-2">
              {{ item.doctorName }} {{ item.doctorProfession }}<a
                    :href="`clinic/${item?.Clinic?.slug}`" alt="" > ({{ item.clinicName }})</a>
            </span>
                <span v-else class="write-name mr-2">{{ getUserName(item) }}</span>
                <template v-if="item?.clinicId">
                  <span class="badge badge-success font-normal font-weight-normal width55">
                    STR 驗證
                  </span>
                </template>
              </div>
            </div>
            <div class="createTime id-tag">ID：{{ item.id }}</div>
            <div class="createTime" data-toggle="tooltip" data-placement="top" :title="item.createdAt"
                 v-html="timeAgo(item.createdAt)"></div>
          </div>
          <div class="write-info">
            <div class="write-depiction" v-html="convertMessage(item)"></div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import HtmlEditorPro from 'Vue/Common/HtmlEditor/HtmlEditorPro.vue';

export default {
  components: {
    HtmlEditorPro,
  },
  props: {
    userPicUrl: {
      type: String,
      default: 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg',
    },
    postUrl: {
      type: String,
      default: '',
    },
    chatItem: {
      type: Object,
      default: () => ({
        id: 0,
      }),
    },
    pageType: {
      type: String,
      default: 'list',
    },
    showReply: {
      type: String,
      default: 'hidden',
    },
    postMaxSize: {
      type: Number,
      default: 0,
    },
    uploadMaxSize: {
      type: Number,
      default: 0,
    },
    maxFileUploads: {
      type: Number,
      default: 0,
    },
    authCheck: {
      type: Boolean,
      default: false,
    },
    questionTemplate: {
      type: String,
      default: '',
    },
    canReply: {
      type: Boolean,
      default: false,
    },
    authUserId: {
      type: Number,
      default: 0,
    },
    itemKey: {
      type: Number,
      default: 0,
    },
    position: {
      type: String,
      default: '',
    },
    pagePath: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      template: '',
      parentId: null,
      rootId: null,
      defaultPicIcon: 'img/fanswoo-framework/admin/sidebar/headPortrait.jpg',
      replyIconData: [],
      repliesContentShow: false,
      replyFormShow: false,
      replyFormPicIds: [],
      ajaxLoading: false,
    };
  },
  computed: {
    newCreate() {
      return !this.chatItem.id;
    },
  },
  mounted() {
    this.init();
    if (this.pageType === 'newCreate') {
      this.template = this.questionTemplate;
    }
    if (this.chatItem?.RootReplies) {
      this.replyIconData = this.chatItem?.RootReplies.filter((item) => item.clinicId);
    }
  },
  updated() {
    this.init();
  },
  methods: {
    init() {
      $('[data-toggle="tooltip"]')
        .tooltip();
    },
    timeAgo(dateTime) {
      const today = moment()
        .startOf('day');
      const momentDateTime = moment(dateTime);

      if (momentDateTime.isSame(today, 'day')) {
        return momentDateTime.locale('zh-tw')
          .fromNow();
      }
      return momentDateTime.locale('zh-tw')
        .format('YYYY/MM/DD');
    },
    toggleReply() {
      this.replyFormShow = !this.replyFormShow;
      this.parentId = this.chatItem.id;
      this.rootId = this.chatItem.rootId ?? this.chatItem.id;
    },
    toggleReplies() {
      this.repliesContentShow = !this.repliesContentShow;
    },
    handleIconError(event) {
      event.target.src = this.defaultPicIcon;
    },
    handleImageError(event) {
      event.target.src = 'img/pic/no_image_icon.png';
    },
    getUserPic(item) {
      if (item?.clinicId) {
        return this.getDoctorPic(item);
      }
      return item?.userPic?.url?.w0h0 ?? this.defaultPicIcon;
    },
    getDoctorPic(item) {
      return item?.DoctorPics?.url?.w0h0 ?? this.defaultPicIcon;
    },
    convertMessage(item) {
      if (this.pageType === 'read') {
        return item.messageRender;
      }

      const maxLength = 150; // 最大字數限制
      const link = `<a href="onlineMedicalConsultation/${item.slug}" >more</a>`;

      // 先將文本中的換行符去掉，然後限制字數
      const text = item.message.replace(/\n/g, ''); // 去掉換行符

      // 截取符合字數限制的文本
      let convertedMessage = text.substring(0, maxLength);

      // 如果原始文本超過字數限制，添加省略號和「更多」連結
      if (text.length > maxLength) {
        convertedMessage += `.......<p>${link}</p>`;
      }

      return convertedMessage;
    },
    submitForm(event) {
      const messageRender = $(event.currentTarget).parent().find('textarea[name="messageRender"]').val();
      const pics = $(event.currentTarget).parent().find('input[name="Pics[]"]').val();

      if (messageRender === undefined || messageRender.length === 0) {
        global.Message.show({
          text: '請輸入訊息內容...',
        });
        return;
      }
      this.ajaxLoading = true;
      global.Message.show({
        text: '正在送出資料...',
      });

      const formData = new FormData();
      formData.append('messageRender', messageRender);
      if (pics) {
        formData.append('Pics[]', pics);
      }
      formData.append('rootId', this.rootId);
      formData.append('parentId', this.parentId);
      formData.append('pageType', this.pageType);

      axios.post(this.postUrl, formData)
        .then((response) => {
        // 處理成功響應
          axios.post('onlineMedicalConsultation/sentNotification', { id: response.data.parameter.id });
          global.Message.show(response.data);
          this.ajaxLoading = false;
        })
        .catch((error) => {
        // 處理錯誤
          console.error(error);
          this.ajaxLoading = false;
        });
    },
    getUserName(chatItem) {
      const userName = chatItem?.userName;

      if (!userName) {
        return '';
      }

      if (chatItem.userId == this.authUserId) {
        return userName;
      }

      if (chatItem.clinicId) {
        return userName;
      }

      const firstChar = userName.charAt(0);
      // 生成9个星号
      const stars = '*'.repeat(9);
      // 拼接第一个字符和9个星号
      return firstChar + stars;
    },
  },
};
</script>
<style lang="scss">
$maincolor: #72ca4a;
.rating-reply {
  padding: 0rem 2rem;
}

.rating-reply-open {
  .evaluation-pic {
    margin-left: 1rem;
  }
}

.evaluation-sum {
  margin-bottom: 1.5rem;

  .tooltip-text {
    visibility: hidden;
    position: absolute;
    z-index: 1;
    color: white;
    font-size: 12px;
    background-color: #192733;
    border-radius: 10px;
    padding: 10px 15px 10px 15px;
    width: 215px;

    &.top {
      top: -40px;
      left: -50%;
    }

    &.bottom {
      top: 50px;
      left: -50%;
    }

    &.left {
      top: -8px;
      right: 120%;
    }

    &.right {
      top: -8px;
      left: 120%;
    }

    .replyNames {
      margin-bottom: 5px;
    }
  }

  .hover-text {
    position: relative;
    display: inline-block;
    font-family: Arial;
    text-align: center;
    cursor: pointer;

    &:hover {
      .tooltip-text {
        visibility: visible;
      }
    }
  }

  .write-message {
    padding-bottom: 1rem;
    border: 2px solid #ccc;

    &.read {
      background: gainsboro;
    }

    .write-line {
      align-items: center;
      border-bottom: 1px solid #ccc;
      display: flex;
      padding: 1rem 2.5rem;

      .user-content {
        flex: 1;
        display: flex;
        align-items: center;
        gap: 10px;
        .user-pic {
          width: 50px;
          height: 50px;
          flex: 0 0 50px;
          border-radius: 50%;
          overflow: hidden;

          img {
            height: 100%;
            width: 100%;
          }
        }
        .wrapper{
          flex-direction: column;
          display: flex;
          justify-content: space-between;
          gap: 5px;
          margin-left: 10px;
        }
      }

      .createTime {
        display: inline-block;
        color: #9f9f9f;
        font-size: 12px;
      }
    }

    .write-info {
      //align-items: flex-start;
      //display: flex;
      padding: 0.8rem 2.5rem 0 2.5rem !important;
      &.block{
        min-height: 92px;
      }
      .write-depiction {
        color: #555;
        flex: 1;
        letter-spacing: 1.5px;
        margin-bottom: 0;
        padding-left: 2rem;
        font-size: 13px;
        font-weight: 300;
        text-align: justify;
        min-height: 2rem;
        p {
          margin-bottom: 0.6rem;
          img{
            width: auto;
            max-width: 100%;
          }
        }
        .cdx-block {
          margin-top: 1rem;
          margin-bottom: 1rem;

          &.table {
            color: #555;
          }

          &.image-tool {
            &.image-tool--stretched {
              .image-tool__image-picture {
                width: 100%;
              }
            }

            .image-tool__image-picture {
              width: auto;
              height: auto;
            }
          }
        }
        .cdx-input {
          padding: 10px 12px;
          outline: none;
          width: 100%;
        }
      }
    }

    .write-footer {
      display: flex;
      justify-content: space-between;

      &.flex-end {
        justify-content: flex-end;
      }

      &.read {
        min-height: auto;
      }

      &.block {
        @media (min-width: 768px) {
          min-height: 60px;
        }
        @media (max-width: 767px) {
          min-height: 100px;
        }
      }

      @media (min-width: 768px) {
        text-align: center;
        align-items: flex-end;
      }
      @media (max-width: 767px) {
        flex-direction: column;
      }

      .replyCount {
        color: #777;
        cursor: pointer;
        display: flex;

        &.read {
          display: none;
        }

        .message-icon {
          display: inline-block;
          margin-right: 0.5rem;
          width: 15px;
        }
        a {
          color: #027de5;
        }
      }

      .replyInfo {
        display: flex;
        justify-content: space-between;
        align-items: flex-end; // 修改為 flex-end
        z-index: 1;

        a {
          color: $maincolor;

          &:hover {
            color: darken($maincolor, 10%);
            transition: 0.3s;

            &::after {
              width: 100%;
              background: #72ca4a;
              transition: 0.3s linear;
            }
          }
        }

        &.read {
          display: none;
        }

        .replyName {
          text-align: left;
        }

        .replyIcon {
          width: 80px;
          height: 50px;
          position: relative; // 添加相對定位
          text-align: left;

          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); // 添加陰影
            background-color: white; // 白色背景
            margin-left: 10px;
          }

          // 使用 @for 循環來動態計算每個圖像的位置
          @for $i from 2 through 6 {
            img:nth-child(#{$i}) {
              position: absolute;
              left: calc(100% + -#{(80 - ($i - 1) * 5)}px);
              top: 0; // 保持頂部對齊
              z-index: calc(-1 * #{$i}); // 設置 z-index
            }
          }
        }
      }
    }
  }

  textarea {
    height: 200px;
  }

  .evaluation-lecturer {
    padding: 0rem 0rem 1rem 1rem;
    align-items: flex-start;
    border: 2px solid #ccc;
    border-top: 0;
    margin-left: 2.5rem;
    position: relative;
    border-left: solid 5px #72ca4a;

    .write-message {
      border: none;
      padding: 0;
      .write-info {
        align-items: flex-start;
        display: flex;
        padding: 0.8rem 2.5rem 0 2.5rem;

        .write-pic {
          border-radius: 50%;
          overflow: hidden;
          flex: 0 0 50px;
          max-height: 50px;
        }

        .write-depiction {
          color: #555;
          flex: 1;
          letter-spacing: 1.5px;
          margin-bottom: 0;
          padding-left: 2rem;
          min-height: 2rem;
          p {
            margin-bottom: 0.6rem;
          }
        }

        .write-footer {
          color: #666;
          font-size: 14px;
          padding: 7px 20px 0;
          text-align: right;
        }
      }

      .write-footer {
        flex-direction: column-reverse;
        min-height: auto;
      }
    }

    &.reply-form {
      display: none;
      padding: 1.5rem 0rem 1rem 4rem;

      .picIcon {
        border-radius: 50%;
        overflow: hidden;
        flex: 0 0 50px;
        max-height: 50px;
      }

      form {
        width: 100%;
      }
      .input-content {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        padding-left: 2rem;
        padding-right: 2rem;

        textarea {
          height: 220px;
          margin-bottom: 15px;
          width: 100%;
        }

        .action-btn {
          background-color: #72ca4a;
          border: none;
          border-radius: 3px;
          color: #fff;
          display: block;
          height: 40px;
          transition: .3s;
          width: 150px;
          &.ajaxLoading{
            background-color: darken(#72ca4a, 20%);
            cursor: not-allowed;
          }
        }
      }
    }

    &.reply-open {
      display: flex;
    }

    &.showReplies {
      display: block;
    }
  }
}
.id-tag{
  margin-right: 10px;
}
.evaluation-lecturer {
  padding: 0rem 0rem 1rem 1rem;
  align-items: flex-start;
  border-left: 0;
  margin-left: 2.5rem;
  position: relative;
  border-left: solid 5px #72ca4a;

  .tooltip-text {
    visibility: hidden;
    position: absolute;
    z-index: 1;
    color: white;
    font-size: 12px;
    background-color: #192733;
    border-radius: 10px;
    padding: 10px 15px 10px 15px;
    width: 215px;

    &.top {
      top: -40px;
      left: -50%;
    }

    &.bottom {
      top: 50px;
      left: -50%;
    }

    &.left {
      top: -8px;
      right: 120%;
    }

    &.right {
      top: -8px;
      left: 120%;
    }

    .replyNames {
      margin-bottom: 5px;
    }
  }

  .hover-text {
    position: relative;
    display: inline-block;
    font-family: Arial;
    text-align: center;
    cursor: pointer;

    &:hover {
      .tooltip-text {
        visibility: visible;
      }
    }
  }

  .write-message {
    //padding-bottom: 1rem;
    border: 2px solid #ccc;
    padding: 0;
    .write-line {
      align-items: center;
      border-bottom: 1px solid #ccc;
      display: flex;
      padding: 1rem 2.5rem;

      .user-content {
        flex: 1;
        display: flex;
        align-items: center;

        .user-pic {
          width: 50px;
          height: 50px;
          flex: 0 0 50px;
          border-radius: 50%;
          overflow: hidden;

          img {
            height: 100%;
            width: 100%;
          }
        }

        .wrapper{
          flex-direction: column;
          display: flex;
          justify-content: space-between;
          gap: 5px;
          margin-left: 10px;
        }
      }

      .createTime {
        display: inline-block;
        color: #9f9f9f;
        font-size: 12px;
      }
    }

    .write-info {
      align-items: flex-start;
      display: flex;
      padding: 0.8rem 2.5rem 0 2.5rem;

      .write-depiction {
        color: #555;
        flex: 1;
        letter-spacing: 1.5px;
        margin-bottom: 0;
        padding-left: 2rem;
        font-size: 13px;
        font-weight: 300;
        text-align: justify;
        min-height: 2rem;
        p {
          margin-bottom: 0.6rem;
        }
      }
    }

    .write-footer {
      display: flex;
      justify-content: space-between;

      &.flex-end {
        justify-content: flex-end;
      }

      &.read {
        min-height: auto;
      }

      @media (min-width: 768px) {
        text-align: center;
        //min-height: 60px;
        align-items: flex-end;
      }
      @media (max-width: 767px) {
        //min-height: 100px;
        flex-direction: column;
      }

      .replyCount {
        color: #777;
        cursor: pointer;
        display: flex;

        &.read {
          display: none;
        }

        .message-icon {
          display: inline-block;
          margin-right: 0.5rem;
          width: 15px;
        }
      }

      .replyInfo {
        display: flex;
        justify-content: space-between;
        align-items: flex-end; // 修改為 flex-end
        &.read {
          display: none;
        }

        .replyName {
          text-align: left;
        }

        .replyIcon {
          width: 80px;
          height: 50px;
          position: relative; // 添加相對定位
          text-align: left;

          img {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.5); // 添加陰影
            background-color: white; // 白色背景
            margin-left: 10px;
          }

          // 使用 @for 循環來動態計算每個圖像的位置
          @for $i from 2 through 6 {
            img:nth-child(#{$i}) {
              position: absolute;
              left: calc(100% + -#{(80 - ($i - 1) * 5)}px);
              top: 0; // 保持頂部對齊
              z-index: calc(-1 * #{$i}); // 設置 z-index
            }
          }
        }
      }
    }
  }

  textarea {
    height: 200px;
  }

  .evaluation-lecturer {
    padding: 0rem 0rem 1rem 1rem;
    align-items: flex-start;
    border: 2px solid #ccc;
    border-top: 0;
    margin-left: 2.5rem;
    position: relative;

    .write-message {
      border: none;

      .write-info {
        align-items: flex-start;
        display: flex;
        padding: 0.8rem 2.5rem 0 2.5rem;

        .write-pic {
          border-radius: 50%;
          overflow: hidden;
          flex: 0 0 50px;
          max-height: 50px;
        }

        .write-depiction {
          color: #555;
          flex: 1;
          letter-spacing: 1.5px;
          margin-bottom: 0;
          padding-left: 2rem;
          min-height: 2rem;
          p {
            margin-bottom: 0.6rem;
          }
        }

        .write-footer {
          color: #666;
          font-size: 14px;
          padding: 7px 20px 0;
          text-align: right;
        }
      }

      .write-footer {
        flex-direction: column-reverse;
      }
    }

    &.reply-form {
      display: none;
      padding: 1.5rem 0rem 1rem 4rem;

      .picIcon {
        border-radius: 50%;
        overflow: hidden;
        flex: 0 0 50px;
        max-height: 50px;
      }

      form {
        width: 100%;
      }

      .input-content {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        padding-left: 2rem;
        padding-right: 2rem;

        textarea {
          height: 220px;
          margin-bottom: 15px;
          width: 100%;
        }

        .action-btn {
          background-color: #72ca4a;
          border: none;
          border-radius: 3px;
          color: #fff;
          display: block;
          height: 40px;
          transition: .3s;
          width: 150px;
        }
      }
    }

    &.reply-open {
      display: flex;
    }
  }
}

.write-name , .replayName {
  a {
    color: #72ca4a;
  }
}

.hidden {
  display: none !important;
}

.show {
  display: block;
}

.replyTime {
  display: inline-block;
  color: #9f9f9f;
  font-size: 12px;
}

.write-footer {
  font-size: 14px;
  text-align: right;
  color: #666;
  padding: 7px 20px 0px;

  .reply-btn {
    margin-left: 15px;
    display: inline-block;
    cursor: pointer;
    color: #72ca4a;
    border-bottom: 1px solid #72ca4a;
    font-size: 18px;
    line-height: 19px;
  }
}

//.owl-carousel .owl-item img {
//  width: 100%; /* 或者你可以指定具体的宽度，如 300px */
//  height: 120px; /* 或者你可以指定具体的高度 */
//  object-fit: contain; /* 如果你希望图片能覆盖整个区域并保持宽高比，可以使用这个属性 */
//}

.owl-stage-outer {
  margin-bottom: 1rem;
}

.bi.bi-hand-thumbs-up, .bi.bi-hand-thumbs-down {
  width: 16px;
  height: 16px;
  opacity: 0.7;
}

.font-normal {
  font-size: 0.8rem;
}
.width55{
  width: 55px;
}

</style>
